export default {
      id: "icon-newsletter-send-usage",
      viewBox: "0 0 23.57 23.58",
      url: __webpack_public_path__ + "Assets/Sprite.svg#icon-newsletter-send",
      toString: function () {
        return this.url;
      }
    }